// Unpublished Work © 2021-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import OnlinkButton from 'Ui/components/common/onlink-button';
import {redirect} from 'Utils/redirect-utils';
import {replaceTranslationNames} from 'Utils/translation-utils';
import {JOHN_DEERE, MY_JOHN_DEERE, ONLINK} from 'Ui/constants/replace-constants';

function LinkProfilePrompt(props) {
    const {
        redirectParam,
        translations
    } = props;

    return (
        <div className='link-profile-prompt'>
            <h1 className='link-header'>
                {
                    replaceTranslationNames(translations.ONLINK_MYJD_LINK_HEADER, {
                        '0': ONLINK,
                        '1': MY_JOHN_DEERE
                    })
                }
            </h1>
            <div className='prompt-message'>
                {
                    replaceTranslationNames(translations.ONLINK_MYJD_LINK_SUBTEXT_1, {
                        '0': ONLINK,
                        '1': MY_JOHN_DEERE,
                        '2': JOHN_DEERE
                    })
                }
            </div>
            <div className='prompt-message'>
                {
                    replaceTranslationNames(translations.ONLINK_MYJD_LINK_SUBTEXT_2, {
                        '0': MY_JOHN_DEERE
                    })
                }
            </div>
            <div className='prompt-actions'>
                <OnlinkButton onClick={() => redirect(`/myjd-decline${redirectParam}`)}>
                    {translations.no}
                </OnlinkButton>
                <OnlinkButton
                    className='primary'
                    onClick={() => redirect('/myjd-register')}
                    variant='primary'
                >
                    {translations.yes}
                </OnlinkButton>
            </div>
        </div>
    );
}

LinkProfilePrompt.propTypes = {
    redirectParam: PropTypes.string,
    translations: PropTypes.translations
};

export default LinkProfilePrompt;
